export { default } from './Content';